// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"ab223c37","395":"ab223c37","457":"c273b556","907":"ab223c37"}[chunkId] + ".chunk.css";
};